import { Title } from '@solidjs/meta'
import type { JSX } from 'solid-js'
import Icon from '~/components/Icon'
import { A } from '~/router'

export default function NotFound(): JSX.Element {
  return (
    <div class="min-h-dvh flex items-center justify-center bg-surface p-4">
      <Title>404 - Página no encontrada - Florez Jaramillo Solutions</Title>
      <div class="text-center max-w-md">
        <h3 class="text-4xl font-bold text-foreground mb-4">Sorry, page not found!</h3>
        <p class="text-foreground-subtle mb-8">Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling.</p>

        <div class="mb-8">
          <Icon icon="edens:404" size={400} class="text-primary-500" />
        </div>

        <A href="/" class="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-lg font-medium hover:brightness-90 transition-colors">
          Go to home
        </A>
      </div>
    </div>
  )
}
